import { useState } from 'react';
import yandex from '../../../../../assets/media/yandex.svg';
import { Row } from '../../../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../components/Basic/Elements';
import { Input, Select } from '../../../../../components/Basic/Inputs';
import { Text } from '../../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS, YANDEX_1, YANDEX_3, YANDEX_4, YANDEX_5, YANDEX_6, YANDEX_7 } from '../../../../../constans';

const MARKETS = [YANDEX_1, YANDEX_3, YANDEX_4, YANDEX_5, YANDEX_6, YANDEX_7];

const YandexContentButton = ({ isAdmin = true, isWarehouse = false, onClick = (_) => _ }) => {
  const [minPurchase, setMinPurchase] = useState(100);
  const [shelfLife, setShelfLife] = useState('-');
  const [isKvant, setIsKvant] = useState(false);
  const [market, setMarket] = useState(MARKETS[0]);

  return (
    <Row style={{ marginLeft: '15px', alignItems: 'flex-end' }}>
      {isAdmin && (
        <>
          {!isWarehouse && (
            <>
              {' '}
              <Select
                label={'Магазин'}
                select={market}
                list={MARKETS}
                onSelect={(v) => setMarket(v)}
                width={'140px'}
                style={{ marginRight: '20px' }}
              />
              <Input
                label={'Мин. закупка'}
                value={minPurchase}
                width={'80px'}
                onBlur={(v) => setMinPurchase(v)}
                style={{ marginRight: '10px' }}
              />
            </>
          )}
        </>
      )}
      <Button type={TYPE_BUTTONS.WHITE} onClick={() => onClick(market, minPurchase, shelfLife, isKvant)}>
        <Icon src={yandex} width={'25px'} style={{ marginRight: '10px' }} />
        Перенести в яндекс
      </Button>
      {isAdmin && (
        <>
          <Row style={{ minWidth: '150px' }}>
            <CheckButton checked={isKvant} onSelect={(v) => setIsKvant(v)} style={{ marginLeft: '10px' }} />
            <Text style={{ marginLeft: '10px', marginTop: '1px' }}>Заливка квантами</Text>
          </Row>
        </>
      )}
    </Row>
  );
};
export default YandexContentButton;
